<template>
    <el-form :model="addForm" :rules="formRules" ref="addForm" label-width="190px" class="demo-ruleForm" :hide-required-asterisk="true">
        <el-form-item label="考试名称" prop="name">
            <el-input v-model.trim="addForm.name" placeholder="2-26个字" maxlength="26" show-word-limit style="width: 500px"></el-input>
        </el-form-item>
        <el-form-item label="试卷分类" prop="level">
<!--            <el-select v-model="addForm.level" placeholder="请选择试卷分类" style="width: 500px" @change="changeLevel">-->
<!--                <el-option label="四级电子商务员" :value="1"></el-option>-->
<!--                <el-option label="三级助理电子商务师" :value="2"></el-option>-->
<!--            </el-select>-->
            <el-cascader v-model="addForm.category_id" style="width: 500px" :props="keyObj" :options="gradeClassList"
                         placeholder="请选择试卷分类" @change="changeLevel"></el-cascader>
        </el-form-item>
        <el-form-item label="开始时间" prop="begin_time">
            <el-date-picker type="datetime" value-format="yyyy-MM-dd HH:mm:ss" :picker-options="pickerOptions"
                            placeholder="请选择开始时间" v-model="addForm.begin_time" style="width: 500px;"></el-date-picker>
        </el-form-item>
        <el-form-item label="结束时间" prop="end_time">
            <el-date-picker type="datetime" value-format="yyyy-MM-dd HH:mm:ss" :picker-options="pickerOptions" @change="selectOverTime"
                            placeholder="请选择结束时间" v-model="addForm.end_time" style="width: 500px;"></el-date-picker>
        </el-form-item>
        <el-form-item label="选择队伍" prop="team_id">
            <el-select v-model="addForm.team_id" placeholder="班级名称" clearable style="width: 500px">
                <el-option v-for="item in teamList" :label="item.name" :value="item.id" :key="`teamList_${item.id}`" :disabled="item.is_used"></el-option>
            </el-select>
        </el-form-item>
        <el-form-item label="考试类型" prop="type">
            <el-radio-group v-model="addForm.type" @change="changeType">
                <el-radio :label="2">模拟考试</el-radio>
                <el-radio :label="1">正式考试</el-radio>
            </el-radio-group>
        </el-form-item>
        <el-form-item label="选择试题" prop="mode">
            <el-radio-group v-model="addForm.mode" @change="changeMode">
                <el-radio :label="1" style="width: 80px">试卷</el-radio>
                <el-radio :label="2">随机试题</el-radio>
            </el-radio-group>
            <el-button @click="getRandomList" type="primary" v-if="addForm.mode === 2" size="medium" style="margin-left: 20px">重新选择</el-button>
        </el-form-item>
        <template v-if="addForm.mode === 1">
            <el-form-item label="试卷模板" prop="paper_id">
                <el-select v-model="addForm.paper_id" placeholder="试卷名称" clearable style="width: 500px" :disabled="examPaperList.length === 0">
                    <el-option v-for="item in examPaperList" :label="item.name" :value="item.id" :key="`examPaperList_${item.id}`"></el-option>
                </el-select>
            </el-form-item>
        </template>
        <template v-else>
            <el-form-item label="理论题" prop="theory_id">
                <el-select v-model="addForm.theory_id" placeholder="试卷名称" clearable style="width: 500px" :disabled="theoryList.length === 0">
                    <el-option v-for="item in theoryList" :label="item.name" :value="item.id" :key="`theoryList_${item.id}`"></el-option>
                </el-select>
                <el-input v-model.trim="addForm.theory_score" disabled style="width: 100px; margin-left: 10px"></el-input>
                <span class="prompt-text">分</span>
            </el-form-item>
<!--            <el-form-item label="商品信息采集与处理" prop="goods_info_collect_name">-->
<!--                <el-input v-model="addForm.goods_info_collect_name" placeholder="试题名称" style="width: 500px" disabled></el-input>-->
<!--                <el-input v-model.trim="addForm.goods_info_collect_score" disabled style="width: 100px; margin-left: 10px"></el-input>-->
<!--                <span class="prompt-text">分</span>-->
<!--            </el-form-item>-->
<!--            <el-form-item label="网店装修" prop="shop_decoration_name">-->
<!--                <el-input v-model="addForm.shop_decoration_name" placeholder="试题名称" style="width: 500px" disabled></el-input>-->
<!--                <el-input v-model.trim="addForm.shop_decoration_score" disabled style="width: 100px; margin-left: 10px"></el-input>-->
<!--                <span class="prompt-text">分</span>-->
<!--            </el-form-item>-->
<!--            <el-form-item label="网店管理" prop="shop_management_name">-->
<!--                <el-input v-model="addForm.shop_management_name" placeholder="试题名称" style="width: 500px" disabled></el-input>-->
<!--                <el-input v-model.trim="addForm.shop_management_score" disabled style="width: 100px; margin-left: 10px"></el-input>-->
<!--                <span class="prompt-text">分</span>-->
<!--            </el-form-item>-->
<!--            <el-form-item label="网络推广" prop="network_promotion_name">-->
<!--                <el-input v-model="addForm.network_promotion_name" placeholder="试题名称" style="width: 500px" disabled></el-input>-->
<!--                <el-input v-model.trim="addForm.network_promotion_score" disabled style="width: 100px; margin-left: 10px"></el-input>-->
<!--                <span class="prompt-text">分</span>-->
<!--            </el-form-item>-->
            <el-form-item label="网店客户服务" prop="store_customer_service_name">
                <el-input v-model="addForm.store_customer_service_name" placeholder="试题名称" style="width: 500px" disabled></el-input>
                <el-input v-model.trim="addForm.store_customer_service_score" disabled style="width: 100px; margin-left: 10px"></el-input>
                <span class="prompt-text">分</span>
            </el-form-item>
<!--            <el-form-item label="电子商务数据收集与清洗" prop="data_capture_clean_name">-->
<!--                <el-input v-model="addForm.data_capture_clean_name" placeholder="试题名称" style="width: 500px" disabled></el-input>-->
<!--                <el-input v-model.trim="addForm.data_capture_clean_score" disabled style="width: 100px; margin-left: 10px"></el-input>-->
<!--                <span class="prompt-text">分</span>-->
<!--            </el-form-item>-->
            <el-form-item label="理论题" prop="theory_rate">
                <el-input-number class="number-input" v-model="addForm.theory_rate" placeholder="设置分值比例" :precision="0" :controls="false" :min="1" :max="99" style="width: 124px;"></el-input-number>
                <span class="prompt-text">%</span>
            </el-form-item>
            <el-form-item label="实操题" prop="practic_rate">
                <el-input-number class="number-input" v-model="addForm.practic_rate" placeholder="设置分值比例" :precision="0" :controls="false" :min="1" :max="99" style="width: 124px;"></el-input-number>
                <span class="prompt-text">%</span>
            </el-form-item>
        </template>
    </el-form>
</template>

<script>
    import { paperListPaper, examGetTheoryByLevel, examRandPaper, examClass, catePage, examGetPaperByCategory, examGetTheoryByCategory, categoryLists } from '@/utils/apis.js'
    export default {
        props: {
            addForm: {
                type: Object,
                default:() => {}
            },
            formRules: {
                type: Object,
                default:() => {}
            },
        },
        data() {
            return {
                teamList: [], // 班级列表
                examPaperList: [], // 试卷列表
                theoryList: [], // 理论题列表
                pickerOptions: {
                    disabledDate(time) {
                        return time.getTime() < Date.now() - 3600 * 1000 * 24;
                    }
                },
                gradeClassList:[], //试卷分类
                keyObj:{
                  label: 'name',
                  value: 'id',
                  children: 'children'
                },
            }
        },
        watch: {
            'addForm.theory_rate'(val) {
                this.addForm.practic_rate = 100 - val
            },
            'addForm.practic_rate'(val) {
                this.addForm.theory_rate = 100 - val
            }
        },
        mounted() {
            this.getCatePage();
            this.getTeamList()
            if (this.addForm.category_id && this.addForm.category_id.length) {
                this.getExamPaperList()
                this.getTheoryList()
            }
        },
        methods: {
            selectOverTime(val){
                if (!this.addForm.begin_time) {
                    this.$message.warning('请先选择开始时间！');
                    this.addForm.end_time = ''
                } else {
                    if (this.addForm.end_time < this.addForm.begin_time) {
                        this.$message.warning('请选择开始时间之后的日期！');
                        this.addForm.end_time = ''
                    }
                }
            },
            // 筛选考试等级
            changeLevel(val) {
                this.examPaperList = []
                this.theoryList = []
                this.getExamPaperList()
                this.getTheoryList()
                if(this.addForm.mode === 2){
                  this.getRandomList()
                }
                this.$emit('update:addForm', {
                    ...this.addForm,
                    paper_id: null,
                    theory_id: null,
                    store_customer_service_name:null,
                    store_customer_service_score:null
                })
            },
            // 获取试卷分类
            getCatePage(){
              let params = {
                type:4
              }
              categoryLists(params).then((res)=>{
                this.gradeClassList = res.data;
              }).catch((err)=>{
                console.log('err',err)
              })
            },
            // 获取班级列表
            getTeamList() {
                examClass().then((res) => {
                    this.teamList = res.data
                })
            },
            // 获取试卷列表
            getExamPaperList() {
                let params = {
                  category_id: this.addForm.category_id[this.addForm.category_id.length - 1]
                }
              examGetPaperByCategory(params).then((res) => {
                    this.examPaperList = res.data
                })
            },
            // 获取理论题列表
            getTheoryList() {
                let params = {
                  category_id: this.addForm.category_id[this.addForm.category_id.length - 1]
                }
              examGetTheoryByCategory(params).then((res) => {
                    this.theoryList = res.data
                })
            },
            // 筛选考试类型，模拟考试或者正式考试
            changeType(val) {
                if (val === 1) {
                    this.$emit('update:addForm', {
                        ...this.addForm,
                        give_type: 2,
                        teacher: [],
                    })
                } else {
                    this.$emit('update:addForm', {
                        ...this.addForm,
                        give_type: 1,
                        teacher: [],
                    })
                }
            },
            // 筛选试卷或者随机试题
            changeMode(val) {
                this.clearFields()
                if (val === 2) {
                    this.getRandomList()
                }
            },
            // 重新选择，随机试题
            getRandomList() {
                let params = {
                  category_id: this.addForm.category_id[this.addForm.category_id.length - 1]
                }
                examRandPaper(params).then((res) => {
                    this.$emit('update:addForm', {
                        ...this.addForm,
                        // goods_info_collect: res.data.goods_info_collect, //商品信息采集与处理
                        // goods_info_collect_name: res.data.goods_info_collect_name,
                        // goods_info_collect_score: res.data.goods_info_collect_score,
                        // shop_decoration: res.data.shop_decoration, // 网店装修
                        // shop_decoration_name: res.data.shop_decoration_name,
                        // shop_decoration_score: res.data.shop_decoration_score,
                        // shop_management: res.data.shop_management, // 网店管理
                        // shop_management_name: res.data.shop_management_name,
                        // shop_management_score: res.data.shop_management_score,
                        // network_promotion: res.data.network_promotion, // 网络推广
                        // network_promotion_name: res.data.network_promotion_name,
                        // network_promotion_score: res.data.network_promotion_score,
                        store_customer_service: res.data.store_customer_service, // 网店客户服务
                        store_customer_service_name: res.data.store_customer_service_name,
                        store_customer_service_score: res.data.store_customer_service_score,
                        // data_capture_clean: res.data.data_capture_clean, // 电子商务数据收集与清洗
                        // data_capture_clean_name: res.data.data_capture_clean_name,
                        // data_capture_clean_score: res.data.data_capture_clean_score,
                    })
                }).catch((err) => {})
            },
            clearFields() {
                for (let key in this.addForm) {
                    if (!this.addForm[key]) {
                        // 切换，清除开启提交做的验证
                        this.$refs['addForm'].clearValidate([key])
                    }
                }
                // this.$refs['addForm'].resetFields();
            },
        }
    }
</script>

<style scoped lang="scss">
    .demo-ruleForm {
        margin: 20px 0 0 60px;
        ::v-deep .el-form-item__label {
            font-size: 16px;
            color: #333;
        }
    }
    .prompt-text {
        font-size: 16px;
        margin-left: 10px;
    }
    .number-input {
        ::v-deep .el-input__inner {
            text-align: left;
        }
    }
</style>